import { Component, OnInit, ViewChild, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { AdminService } from '../admin.service';
import { Flow, FeatureStatusUpdate, Control, draftCategory } from '../../shared/models/Flow';
import { SelectionModel } from '@angular/cdk/collections';
import { environment } from '../../../environments/environment';
import { TCCPLocalStorageService } from '../../shared/services/tccp-local-storage.service';
import { PreviewFeatureFlowDialogComponent } from '../../shared/components/preview-feature-flow-dialog/preview-feature-flow-dialog.component';
import { TCCPCommonService } from '../../shared/services/tccp-common.service';
import * as _ from 'lodash';
import { DialogFeatureDraftComponent } from '../dialog-feature-draft/dialog-feature-draft.component';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-publish-feature',
  templateUrl: './publish-feature.component.html',
  styleUrls: ['./publish-feature.component.scss']
})
export class PublishFeatureComponent implements OnInit {

  public displayedColumns: string[] = [];
  public resourceDataSource = new MatTableDataSource([]);
  public features: Flow[];
  public feature: FeatureStatusUpdate = <FeatureStatusUpdate>{};
  public isDraft = false;
  public isRestricted = false;
  public success: string[] = [];
  public hasPermission = false;


  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  selection = new SelectionModel<Flow>(true, []);

  constructor(
    private dialog: MatDialog, private commonService: TCCPCommonService,
    private adminService: AdminService, private datePipe: DatePipe, public authService: MsalService,
    public storageService: TCCPLocalStorageService, private router: Router) {
    this.displayedColumns = ['select', 'controls.featureName', 'featureType', 'lastModifiedBy', 'lastModifiedDate', 'publishedDate'];
  }

  ngOnInit() {
    this.setUserPolicy();
    this.getAllFeatures();
    this.adminService.refreshDashboard.subscribe(data => {
      if (data) {
        this.getAllFeatures();
      }
    });
  }

  async setUserPolicy(): Promise<void> {
    if (!this.storageService.getRoles()){
      const upn = this.storageService.getUpn();
      await this.commonService.getAccessRole(upn).subscribe(data => {
        this.storageService.setRoles(_.map(data,'roles'));
      });
    } 
    const roles = this.storageService.getRoles();
    const userAccess = this.commonService.getAccess('Publish', roles);
    const accessLevel = _.get(userAccess[0], 'accessLevel');
    if (accessLevel === 1) {
      this.hasPermission = true;
    } else if (accessLevel === 3) {
      this.hasPermission = false;
    }
  }

  getAllFeatures() {
    this.adminService.getFlow(null, null, 'published').subscribe(response => {
      let sortedContents = [];
      this.selection = new SelectionModel<Flow>(true, []);
      sortedContents = response.sort((val1, val2) => {
        return new Date(val2.publishedDate).getTime() - new Date(val1.publishedDate).getTime()
      });

      this.resourceDataSource.data = sortedContents;
      setTimeout(() => {
        this.resourceDataSource.sortingDataAccessor = (item, property) => {
          switch (property) {
            case 'controls.featureName': return item.controls[0].featureName;
            case 'lastModifiedDate': {
              return new Date(item.lastModifiedDate).getTime();
            }
            case 'publishedDate': {
              return new Date(item.publishedDate).getTime();
            }
            default: return item[property];
          }
        };
        this.resourceDataSource.sort = this.sort;
        this.resourceDataSource.paginator = this.paginator;
      });

      this.resourceDataSource.filterPredicate = (data: any, filter) => {
        const dataStr = JSON.stringify(data).toLowerCase();
        return dataStr.indexOf(filter) !== -1;
      };

    });
  }

  applyFilter(filterValue: string) {
    this.resourceDataSource.filter = filterValue.trim().toLowerCase();

  }

  closeSuccess() {
    this.success = [];
  }

  moveToDraft() {
    this.adminService.closeFeatureExpansionPanel.emit(true);
    this.success = [];
    this.feature.issueId = this.selection.selected.map(x => x.issueId);
    this.feature.source = this.adminService.selectedApplication;
    this.feature.status = 'draft';
    const dialogRef = this.dialog.open(DialogFeatureDraftComponent);

    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        let draftCategory: draftCategory = <draftCategory>{};
        draftCategory.draftCategory = data.data.draftCategory;
        draftCategory.draftMessage = data.data.draftMessage + '';
        this.feature.draftCategory = draftCategory;
        this.adminService.updateStatus(this.feature).subscribe(data1 => {
          if (data1) {
            this.selection.selected.forEach(element => {
              if (data1.indexOf(element.issueId) > -1) {
                this.success.push(element.controls[0].featureName);
              }
            });
            this.selection = new SelectionModel<Flow>(true, []);
            this.getAllFeatures();
          }
        });
      }
    });
  }

  onTabChanged(event) {
    if (event.index === 1) {
      this.isDraft = true;
    } else {
      this.isDraft = false;
      this.getAllFeatures();
    }
  }
  previewFeature() {
    this.adminService.closeFeatureExpansionPanel.emit(true);
    this.storageService.setPreviewFromPublish(true);
    this.storageService.setReview(false);
    environment.applicationName = this.adminService.selectedApplication;
    const dialogRef = this.dialog.open(PreviewFeatureFlowDialogComponent, {

      data: this.selection.selected.map(x => x.controls[0]), position: {
        top: '10px',
        right: '10px',
        left: '10px',
        bottom: '10px'
      },
      id: environment.applicationName + '-preview-dialog-container',
      height: '97%',
      width: '98vw',
      maxWidth: '100vw',
      panelClass: 'full-screen-modal',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.storageService.setPreviewFromPublish(false);
      if (result) {

      }
    });
  }

  navigateToSupportTopic(control) {
    const selectedIssueId: string = control['issueId'];
    this.adminService.isFeatureInViewMode = true;
    this.adminService.selectedFeatureTargetId = selectedIssueId;
    this.router.navigate(['admin/feature']);
  }

}



